'use client';

import * as RT from '@radix-ui/react-toast';
import * as React from 'react';
import { FiAlertOctagon, FiAlertTriangle, FiCheckCircle, FiInfo, FiX } from 'react-icons/fi';

import { Row } from '@/component/parts/layout/Row/Row';

import * as styles from './toast.css';
import { useToastDispatchContext } from './ToastContext';
import { ToastValues } from './ToastValues';

export const Toast: React.FC<{ values?: ToastValues }> = ({ values }) => {
  const dispatchContext = useToastDispatchContext();

  React.useEffect(() => {
    return () => {
      dispatchContext?.(undefined);
    };
  }, [dispatchContext]);

  return (
    <RT.Root
      className={styles.root[values?.variant ?? 'default']}
      duration={values?.duration ?? 5 * 1000}
      open={values !== undefined}
      onOpenChange={(open) => {
        if (!open) {
          dispatchContext?.(undefined);
        }
      }}
    >
      <RT.Title className={styles.title}>
        <Row>
          {values?.variant === 'success' ? (
            <FiCheckCircle className={styles.icon['success']} />
          ) : values?.variant === 'warn' ? (
            <FiAlertTriangle className={styles.icon['warn']} />
          ) : values?.variant === 'error' ? (
            <FiAlertOctagon className={styles.icon['error']} />
          ) : (
            <FiInfo className={styles.icon['default']} />
          )}
          <span>{values?.message}</span>
        </Row>
      </RT.Title>
      <RT.Close aria-label="Close">
        <FiX className={styles.close[values?.variant ?? 'default']} />
      </RT.Close>
    </RT.Root>
  );
};
